import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="paddle"
export default class extends Controller {
  static values = {
    token: String,
    customerId: String,
    priceId: String,
    successUrl: String,
  };

  connect() {
    Paddle.Checkout.open({
      customer: {
        id: this.customerIdValue,
      },
      items: [
        {
          priceId: this.priceIdValue,
          quantity: 1,
        },
      ],
      settings: {
        displayMode: "overlay",
        variant: "one-page",
        theme: "dark",
        successUrl: this.successUrlValue,
      },
    });
  }
}
